module.exports = __webpack_public_path__ + "img/ic_bed_heat2.023d8ae7.png";